import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
// Analytics card for dashboard metrics with optional charts
const AnalyticsCard = React.forwardRef(({ className, title, value, subtitle, change, icon, chart, color = 'blue', variant = 'default', ...props }, ref) => {
    const colorClasses = {
        blue: {
            gradient: 'bg-gradient-to-r from-blue-500 to-blue-600',
            icon: 'text-blue-600 bg-blue-100 dark:bg-blue-900/30',
            change: 'text-blue-600'
        },
        green: {
            gradient: 'bg-gradient-to-r from-green-500 to-green-600',
            icon: 'text-green-600 bg-green-100 dark:bg-green-900/30',
            change: 'text-green-600'
        },
        red: {
            gradient: 'bg-gradient-to-r from-red-500 to-red-600',
            icon: 'text-red-600 bg-red-100 dark:bg-red-900/30',
            change: 'text-red-600'
        },
        yellow: {
            gradient: 'bg-gradient-to-r from-yellow-500 to-yellow-600',
            icon: 'text-yellow-600 bg-yellow-100 dark:bg-yellow-900/30',
            change: 'text-yellow-600'
        },
        purple: {
            gradient: 'bg-gradient-to-r from-purple-500 to-purple-600',
            icon: 'text-purple-600 bg-purple-100 dark:bg-purple-900/30',
            change: 'text-purple-600'
        },
        indigo: {
            gradient: 'bg-gradient-to-r from-indigo-500 to-indigo-600',
            icon: 'text-indigo-600 bg-indigo-100 dark:bg-indigo-900/30',
            change: 'text-indigo-600'
        },
        pink: {
            gradient: 'bg-gradient-to-r from-pink-500 to-pink-600',
            icon: 'text-pink-600 bg-pink-100 dark:bg-pink-900/30',
            change: 'text-pink-600'
        }
    };
    const trendIcons = {
        up: '↗',
        down: '↘',
        neutral: '→'
    };
    const trendColors = {
        up: 'text-green-600',
        down: 'text-red-600',
        neutral: 'text-gray-600'
    };
    if (variant === 'gradient') {
        return (_jsx("div", { ref: ref, className: cn('rounded-lg shadow-lg text-white overflow-hidden', colorClasses[color].gradient, className), ...props, children: _jsxs("div", { className: "p-6", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { className: "flex-1", children: [_jsx("h3", { className: "text-white/80 text-sm font-medium mb-2", children: title }), _jsx("div", { className: "text-3xl font-bold text-white mb-1", children: value }), subtitle && (_jsx("p", { className: "text-white/70 text-sm", children: subtitle })), change && (_jsxs("div", { className: "mt-2 text-white/90 text-sm flex items-center", children: [_jsx("span", { className: "mr-1", children: trendIcons[change.trend] }), change.value, change.period && (_jsxs("span", { className: "text-white/70 ml-1", children: ["from ", change.period] }))] }))] }), icon && (_jsx("div", { className: "text-white/80 text-2xl", children: icon }))] }), chart && (_jsx("div", { className: "mt-4", children: chart }))] }) }));
    }
    return (_jsx("div", { ref: ref, className: cn('bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm overflow-hidden', className), ...props, children: _jsxs("div", { className: "p-6", children: [_jsxs("div", { className: "flex items-center justify-between mb-4", children: [_jsx("h3", { className: "text-gray-600 dark:text-gray-400 text-sm font-medium", children: title }), icon && (_jsx("div", { className: cn('w-10 h-10 rounded-lg flex items-center justify-center', colorClasses[color].icon), children: _jsx("div", { className: "text-lg", children: icon }) }))] }), _jsxs("div", { className: "space-y-2", children: [_jsx("div", { className: "text-3xl font-bold text-gray-900 dark:text-gray-100", children: value }), subtitle && (_jsx("p", { className: "text-gray-600 dark:text-gray-400 text-sm", children: subtitle })), change && (_jsxs("div", { className: cn('text-sm flex items-center', trendColors[change.trend]), children: [_jsx("span", { className: "mr-1", children: trendIcons[change.trend] }), change.value, change.period && (_jsxs("span", { className: "text-gray-500 ml-1", children: ["from ", change.period] }))] }))] }), chart && (_jsx("div", { className: "mt-4", children: chart }))] }) }));
});
AnalyticsCard.displayName = 'AnalyticsCard';
export { AnalyticsCard };
